import { ChangeDetectionStrategy, Component, HostBinding, input, ViewEncapsulation } from '@angular/core';
import { JoinClassNamesPipe } from '@shared/join/join-class-names.pipe';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { NgOptimizedImage } from '@angular/common';
import { BackgroundImageWrapper } from '@shared/content-wrapper/content-wrapper.type';
import { AssetPath } from '@shared/asset/asset.type';

@Component({
    selector: 'companyid-content-wrapper',
    imports: [JoinClassNamesPipe, AssetPipe, NgOptimizedImage],
    templateUrl: './content-wrapper.component.html',
    styleUrl: './content-wrapper.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentWrapperComponent {
    public classNames = input<string>('');
    public isDark = input(false, {
        transform: (value: boolean | '') => value === '' || value,
    });
    public assetPath = input<AssetPath | undefined>();

    public readonly imgCommonStyles = 'absolute object-cover w-screen left-0 right-0 h-full';
    public readonly backgroundContent: BackgroundImageWrapper[] = [
        { imgPath: 'bg-desk', imgStyles: 'tab:hidden mob:hidden' },
        { imgPath: 'bg-tab', imgStyles: 'desk:hidden mob:hidden' },
        { imgPath: 'bg-mob', imgStyles: 'tab:hidden desk:hidden' },
    ];

    @HostBinding('class')
    public get mainClass(): string {
        return ['flex flex-col relative', this.isDark() ? 'bg-dark' : ''].join(' ');
    }
}
